<template>
  <div>
    <text-box-title
    title="Tax Payment FAQ"
    default="false"
    align="left"
    class="mt-3"
    role="tablist">
    </text-box-title>

    <!-- Here's the FAQ listings -->
    <collapse-view
    group="faq"
    slot-id="1"
    class="mt-3 ml-3 mr-3"
    title="I don't agree with the value that has been placed on my property. What can I do?">
        <p class="col-md-6 mt-3">
          If you would like to file an appeal contesting the valuation of your property, please contact the Assessors Office at <span class="one-line">(740) 283-8518</span>, and you will be sent an appeal form.
          Upon receipt of your appeal form you will be notified of your hearing date with the Board of Revisions. The hearing will take less than one hour.
        </p>
        <p class="col-md-6 mt-3">
          Any information provided by you will be taken into account in reconsidering the appraised value of your property.
          The time to file is between January 1 and March 31; you would have had to acquire the property in question before December 31.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="2"
    class="mt-3 ml-3 mr-3"  
    title="Why is the old owners name on my tax bill?">
        <p class="col-md-6 mt-3">
          The name of the owner of record for the tax year we are billing always appears on the tax bill. The name on the bill will change in January of the next year.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="3"
    class="mt-3 ml-3 mr-3"  
    title="Why are my taxes billed a year behind?">
        <p class="col-md-6 mt-3">
          Real property taxes in Ohio are not determined before October 1 annually, as taxes are assessed at the end of the period not the beginning.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="4"
    class="mt-3 ml-3 mr-3"  
    title="How do I make out my check?">
        <p class="col-md-6 mt-3">
          You can make your check or money order payable to: 
          <span class="text-bold"><span class="one-line">Jefferson County Treasurer</span> or <span class="one-line">Brian J. Scarpone Treasurer</span></span>
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="5"
    class="mt-3 ml-3 mr-3"  
    title="Can delinquent taxes be paid in payments?">
        <p class="col-md-6 mt-3">
          The Treasurer's Office may enter into an agreement with a delinquent taxpayer. Depending on how much you owe will determine the number of payments. 
          The payments are made during consecutive semi-annual tax paying periods, along with the full amount of current taxes the due and payable.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="6"
    class="mt-3 ml-3 mr-3"  
    title="Can delinquent taxes be paid in payments?">
        <p class="col-md-6 mt-3">
          The Treasurer's Office may enter into an agreement with a delinquent taxpayer. Depending on how much you owe will determine the number of payments. 
          The payments are made during consecutive semi-annual tax paying periods, along with the full amount of current taxes the due and payable.
        </p>
        
        <p class="col-md-6 mt-3">
          Once you start a contract to bring you current, no further interest or penalty is added. Failure to pay installments and current taxes when due, 
          will render the contract void and ALL interest previously accrued will be charged against the property.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="7"
    class="mt-3 ml-3 mr-3"  
    title="What happens if I do not pay my taxes?">
        <p class="col-md-6 mt-3">
          If your taxes become delinquent more than 1 year, the Treasurer will file with the County Prosecutor's Office to sell the property at a Treasurer's sale.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="8"
    class="mt-3 ml-3 mr-3"  
    title="Do I always receive a tax bill?">
        <p class="col-md-6 mt-3">
          No, if your taxes are in escrow, to be paid by your lending institution, they will receive the tax bill and should inform you of the amount paid.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="9"
    class="mt-3 ml-3 mr-3"  
    title="What if I do not receive a tax bill, do I still have a penalty?">
        <p class="col-md-6 mt-3">
          Failure to receive a tax bill does not excuse or delay the payment nor does it excuse any penalty or interest. The due date is published in the 
          Steubenville Herald Star about 10 days prior to the due date; also a notice to the taxpayers is published at intervals of 3 weeks prior to the due date. 
          If you do not receive the tax bill you should call our office at 740-283-8572 and request a bill.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="10"
    class="mt-3 ml-3 mr-3"  
    title="How much is the penalty?">
        <p class="col-md-6 mt-3">
          Ohio Revised Code 323.12 requires a 10% penalty be charged against the unpaid balance of one-half of current taxes. If total amount of taxes are not 
          paid on second installment of taxes a 10% penalty shall be charged on the balance of the total amount of unpaid current taxes.
        </p>
        
        <p class="col-md-6 mt-3">
          After second installment, interest is charged against delinquent taxes other than the current taxes at a rate per annum (set by the State of Ohio). 
          On the 1st day of December interest is charged against All delinquent taxes.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="11"
    class="mt-3 ml-3 mr-3"  
    title="If I mail my tax payment on the due date, is it going to be late?">
        <p class="col-md-6 mt-3">
          No, postal regulations state that the postmark of the due date is to be considered current.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="12"
    class="mt-3 ml-3 mr-3"  
    title="Where do my taxes go?">
        <p class="col-md-6 mt-3">
          Most of your tax dollars go to support the schools in your district. We have included on your tax bill a breakout of your tax dollars.
        </p>
    </collapse-view>

    <collapse-view
    group="faq"
    slot-id="13"
    class="mt-3 ml-3 mr-3"  
    title="I received my tax bill in the mail, but it was supposed to go to my bank. What do I do?">
        <p class="col-md-6 mt-3">
          This most commonly happens if you refinanced, or in any way changed the information on your tax bill. First don't worry, your tax 
          agent knows they owe the taxes and will usually pay them anyway.
        </p>

        <p class="col-md-6 mt-3">
          To correct the mailing of the bill, ask your bank or lender to request in writing a change of mailing from the Treasurers Office.
        </p>
    </collapse-view>

  </div>
</template>

<script>

import CollapseView from '@/components/display-utils/CollapseView.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'

export default {
  components: {
    CollapseView,
    TextBoxTitle
  },
  data () {
    return {}
  }
}
</script>

<style scoped>

.collapse {
  width: 100%;
}

.gutter {
  margin-right: 20px;
}
</style>
